import { FeaturedIcon } from "@unified-checkout/design-system";

import type { IStatusContent } from "@app/dashboard/types/innerLayout/status-content";
import { ICON_COLOR_MAPPER } from "@app/dashboard/constants/status-content";
import { Circle } from "@unified-checkout/design-system/icons/index";

import styles from "./status-content.module.scss";


export const StatusContent = ({
  state = 'default',
  statusIcon = Circle,
  title,
  supportingText,
  keepIconDefaultColors = true
}: IStatusContent) => {

  return (
    <section className={styles['status-content']} data-status-content-state={state}>
      {
        statusIcon &&
        <div className={styles['status-content__icon']}>
          <FeaturedIcon
            icon={statusIcon}
            size="xl"
            color={ICON_COLOR_MAPPER[state]}
            keepIconDefaultColors={keepIconDefaultColors}
          />
        </div>
      }

      {title && <h3 className={styles['status-content__title']}>{title}</h3>}

      {
        supportingText &&
        <p className={styles['status-content__supporting-text']}>
          {supportingText}
        </p>
      }
    </section>
  )
}
